import React from 'react';

export const NEARBY_AMENITY_KEYS = [
  { id: 'airport', label: 'Airport', placeholder: 'e.g. 25 min (JFK)', icon: 'plane' },
  { id: 'train', label: 'Train', placeholder: 'e.g. 5 min', icon: 'train' },
  { id: 'bus', label: 'Bus', placeholder: 'e.g. 2 min', icon: 'bus' },
  { id: 'supermarket', label: 'Supermarket', placeholder: 'e.g. 3 min', icon: 'shopping-cart' },
  { id: 'highway', label: 'Highway', placeholder: 'e.g. 8 min', icon: 'road' },
];

const NearbyAmenitiesFields = ({ form, update, variant = 'boxes' }) => {
  if (variant === 'compact') {
    return (
      <div className="nearby-amenities-fields nearby-amenities-fields--compact">
        {NEARBY_AMENITY_KEYS.map(({ id, label, placeholder }) => (
          <label key={id} className="nearby-amenities-fields__item">
            <span>{label}</span>
            <input
              type="text"
              className="list-v2-input"
              value={form[`nearby_${id}`] || ''}
              placeholder={placeholder}
              onChange={(e) => update(`nearby_${id}`, e.target.value)}
            />
          </label>
        ))}
      </div>
    );
  }

  return (
    <div className="nearby-amenities-grid">
      {NEARBY_AMENITY_KEYS.map(({ id, label, placeholder, icon }) => (
        <label key={id} className="nearby-input-box">
          <i className={`fas fa-${icon}`} aria-hidden="true"></i>
          <span className="nearby-input-box__label">{label}</span>
          <input
            type="text"
            className="nearby-input-box__input"
            value={form[`nearby_${id}`] || ''}
            placeholder={placeholder}
            onChange={(e) => update(`nearby_${id}`, e.target.value)}
            aria-label={label}
          />
        </label>
      ))}
    </div>
  );
};

export default NearbyAmenitiesFields;
